<div class="confirm-proceed-wrapper" [ngClass]="[styleClass]">
  <h2>{{ header }}</h2>
  <p>{{ message }}</p>
  <div class="actions-footer">
    <button (click)="cancel()" class="status-cancel">{{ cancelLabel }}</button>
    <button (click)="reject()" class="status-rejectbtn">{{ rejectLabel }}</button>
    <button (click)="confirm()" class="status-confirm">{{ confirmLabel }}</button>
  </div>
</div>
